/**
 Copyright Highway9 Networks Inc.
 */
import Radio from "../types/radio";
import APIService from "./APIServices";
import { authenticationService } from "./authentication-service";
import { SASProcessed } from "~/types/SASLogs";
import { MetricGraph } from "~/types/metricGraph";
import { ThirdPartyRequest } from "~/types/ThirdParty";
import { apiFetch } from "~/sw";
import { RadioAvailableUpgrade, RadioUpgrade } from "~/types/AvailableUpgrades";
import { RadioManager } from "~/types/RadioManger";

const radioAPI = new APIService<Radio>("radios");
const radioCoreKPIsList = new APIService<MetricGraph>("radios/metrics/kpis");
const radioManagerAPI = new APIService<RadioManager>("accessConfig");
const option43API = new APIService<any>("tools/dhcp/option43");

export const radioService = {
  getRadios: async (query?: Record<string, any>) => await apiFetch("fetchRadio", authenticationService.currentUserValue!.token, query),
  createRadio: radioAPI.create,
  updateRadio: radioAPI.update,
  deleteRadio: radioAPI.delete,
  clearSerialNumber,
  getMetricsAggregate: radioAPI.getAggregateMetrics,
  getMetrics: radioAPI.getMetrics,
  signCpi,
  getSASLogsBySerialNo,
  getRadioGroupAvailableUpgrades,
  get: radioAPI.get,
  getRadioUpgrades: async () => {
    const response = await radioAPI.get<RadioUpgrade[]>("availableUpgrades") // Assuming this endpoint returns the available upgrades for radios
    return response
  }
  ,
  // POST /tools/dhcp/option43/query
  getOption43Config: async (payload: { id: string; securityGatewayIp: string; ntpServerIp: string }) => {
    return await option43API.post("query", payload);
  }
};

export const radioCoreKPIsListService = {
  getRadioCoreKPIsList : radioCoreKPIsList.getAll
}
async function clearSerialNumber(id: string) {
  return radioAPI.post(`/${id}/clearSerialNumber`);
}


export async function getThirdPartyPublicCellTowers(query: ThirdPartyRequest) {
  return await apiFetch("fetchPublic", query, authenticationService.currentUserValue!.token)
}

export async function getThirdPartyCBRS(query: ThirdPartyRequest) {
  return await apiFetch("fetchCBRS", query, authenticationService.currentUserValue!.token)
}

export async function getThirdPartyPAL(query: ThirdPartyRequest) {
  return await apiFetch("fetchPAL", query, authenticationService.currentUserValue!.token)
}

export async function getRadioPalConflict() {
  return await apiFetch("fetchRadioPalConflict", authenticationService.currentUserValue!.token)
}

type RadioManagerQuery = {
  filter: {
   objectId : string;
  }
}
export const radioManagerService = {
  getRadioManagersById : async (query: RadioManagerQuery) => {
    const response = await radioManagerAPI.post("query", query) as unknown as RadioManager[];
    return response;
  }
}

async function signCpi(data: any, file: any) {
  const formData = new FormData();
  if (file !== "") {
    formData.append("upfile", file);
  }
  formData.append("metaData", JSON.stringify(data));
  const requestOptions = {
    method: "POST",
    headers: {
      accept: "*/*",
      Authorization: "Bearer " + authenticationService.currentUserValue?.token,
    },
    body: formData,
  };

  return fetch(`/api/v1/orch/radios/operations/signByCpi`, requestOptions);
}

type SASLogRequest = {
  interval : {
    startTime : number;
    endTime : number;
  },
  logType : "SIMPLIFIED" | "RAW" | string & {},
  level : "DEBUG" | "INFO" | "WARN" | "ERROR" | string & {},
  cell : number
}

async function getSASLogsBySerialNo(serialNumber: string, payload: SASLogRequest) {
  const data = await radioAPI.post(`${serialNumber}/SAS/getLogs`, payload) as unknown as SASProcessed[];
  return data;
}

async function getRadioGroupAvailableUpgrades(payload: any) {
  const requestBody = payload ? payload : { filter: {} };
  const response  = await radioAPI.post(`releases/query`, requestBody) as unknown as RadioAvailableUpgrade[];
  return response;
}